import React from 'react';
import { Stack } from '@mui/material';
import ItemReplacementsBox from './ItemReplacementsBox';
import CampaignBox from './CampaignBox';
import FastTrackBanner from './FastTrackBanner';
import PacksBox from './PacksBox.jsx';
import LoadingIndicator from '../../LoadingIndicator';

function CurrentCampaignTab({ campaigns, packsSummary, replacementsSummary, isLoading }) {
    const [isShowingBanner, setIsShowingBanner] = React.useState(true);
    const hasPacks = packsSummary && packsSummary.packs_total_count > 0;
    const hasReplacements = replacementsSummary && replacementsSummary.replacements_total_count > 0;

    if (isLoading) {
        return <LoadingIndicator />;
    }

    return (
        <Stack px={2} spacing={2} pb={5}>
            { isShowingBanner && !hasPacks &&
                <FastTrackBanner campaigns={campaigns} onClose={() => setIsShowingBanner(false)} />
            }
            { hasPacks && 
                <PacksBox packsSummary={packsSummary} />
            }
            { hasReplacements &&
                <ItemReplacementsBox replacementsSummary={replacementsSummary} />
            }
            { campaigns?.map((campaign) => (
                <CampaignBox key={campaign.id} campaign={campaign} />
            ))}
        </Stack>
    );
}

export default CurrentCampaignTab;
